export default __webpack_public_path__ + "static/media/TRANSPORT 2.0b1fad9b.jpg";